import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { SpinnerService } from 'shared-components';
import { AdminService } from '../../../services/admin.service';

@Component({
  selector: 'app-lista-provincias',
  templateUrl: './lista-provincias.component.html'
})

export class ProvinciasComponent implements OnInit {

  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;
  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 0;
  public totalItems: number;
  public readonly visiblePages = 3;

  public new = false;
  public provinciasEditable;
  public provinciasList = [];

  public _filters;

  @Input() id;
  @Output() refresh = new EventEmitter<boolean>();
  @Output() pushMessage = new EventEmitter<string>();

  constructor(private readonly _spinnerService: SpinnerService,
    private readonly _adminService: AdminService,
    private readonly _sessionContext: SessionContextService) { }

  ngOnInit() {
    this.getProvinciasByPais();
  }

  public get role() {
    return this._sessionContext.sessionUser.role;
  }

  public pageChange(page) {
    this.currentPage = page - 1;
    this.getProvinciasByPais();
  }

  public getProvinciasByPais() {
    this._filters = {
      paisId: this.id,
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage
    };
    this._spinnerService.showSpinner();
    this._adminService.getProvinciasByPaisId(this._filters).toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then((resp) => {
      this.totalItems = resp.paginacionMeta.totalCount;
      this.provinciasList = resp.lista;
    });
  }

  public editableChanged(provincia) {
    this.provinciasEditable = provincia;
    this.new = false;
  }

  public toRefresh(value) {
    this.refresh.emit(value);
    this.provinciasEditable = '';
  }
}
